export default "__VITE_ASSET___Isvoppa__"